import "./i18n.tsx";

// BankID returns to /bank-id/callback/#access_token=... but MSAL v4 aggressively
// parses any hash containing standard OIDC params (like access_token) and tries
// to process it as a B2C redirect. This causes state transition loops and crashes.
// We save the BankID hash to sessionStorage and clear it from the URL BEFORE
// MSAL initializes, so AMLRedirectPage can still read the token.
if (
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/bank-id/callback") &&
    window.location.hash.includes("access_token")
) {
    sessionStorage.setItem("bankid_hash", window.location.hash);
    // Remove hash without triggering navigation/reload
    history.replaceState(null, "", window.location.pathname + window.location.search);
}

export { wrapPageElement, wrapRootElement } from "./gatsby-shared";
